import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { ProductV2 } from '@banyan/commons/models/order/product.model';
import { ProductPrice } from '@banyan/commons/models/product-price.model';
import { AdminService } from '@banyan/modules/admin/services/admin.service';


@Component({
  selector: 'app-admin-product-card',
  templateUrl: './admin-product-card.component.html',
  styleUrl: './admin-product-card.component.scss',
})
export class AdminProductCardComponent implements OnInit {
  fb = inject(FormBuilder);
  adminService = inject(AdminService);
  @ViewChild('triggerMenu') menuTrigger: MatMenuTrigger | undefined;
  @Input() product?: ProductV2;
  @Output() remove = new EventEmitter<void>();
  @Output() editedProduct = new EventEmitter<ProductV2>();

  editForm: FormGroup;
  isEditing: boolean = false;

  constructor() {
    this.editForm = this.createForm();
    this.adminService.isProductChange.set(false);
  }

  ngOnInit(): void {
    if (this.product) {
      this.updateForm();
    }
    this.isEditedForm();
  }

  private createForm(): FormGroup {
    return this.fb.group({
      name: ['', []],
      description: ['', []],
      price: ['', []],
      minQuantity: [{ value: '', disabled: true }],
    });
  }

  private updateForm(): void {
    this.editForm.patchValue({
      name: this.product?.name,
      description: this.product?.description,
      price: this.product?.price?.value,
      minQuantity: this.product?.minQuantity,
    });
  }

  openPopup(): void {
    this.menuTrigger?.openMenu();
  }

  closePopup(): void {
    this.menuTrigger?.closeMenu();
  }

  removeProduct(): void {
    this.remove.emit();
  }

  editProduct(): void {
    this.adminService.isEditing.set(true);
    this.isEditing = true;
    this.editForm.enable();
    this.editForm.get('minQuantity')?.disable();
  }

  isEditedForm(): void {
    const initialValue = this.editForm.value;
    this.editForm.valueChanges.subscribe(() => {
      const change = Object.keys(initialValue).some(
        key => this.editForm.value[key] !== initialValue[key],
      );
      this.adminService.isProductChange.set(change);
    });
  }

  saveProduct(): void {
    if (this.editForm.valid && this.product) {
      const updatedValues = this.editForm.value;
      delete updatedValues.minQuantity;
      const hasChanges = Object.keys(updatedValues).some((key) => {
        const formValue = updatedValues[key];
        const productValue = this.product?.[key as keyof ProductV2];

        switch (key) {
          case 'price':
            return formValue !== (productValue as ProductPrice)?.value;

          default:
            return formValue !== productValue;
        }
      });

      if (hasChanges) {
        this.product = {
          ...this.product, ...updatedValues,
          price: {
            currencyCode: this.product.price?.currencyCode,
            value: updatedValues.price,
          },
        };

        this.editedProduct.emit(this.product);
      }

      this.isEditing = false;
      this.adminService.isEditing.set(false);
      this.adminService.isProductChange.set(false);
      this.editForm.disable();
    }
  }

  cancel() {
    this.adminService.isEditing.set(false);
    this.adminService.isProductChange.set(false);
    this.isEditing = false;
  }

  handleReviewed(): void {
    if(this.product){
      this.product = { ...this.product, isWaitingForReview: false };
      this.editedProduct.emit(this.product);
    }
  }
}
